module.exports = __webpack_public_path__ + "img/icon_menu_home_main.002e740a.svg";